import React from 'react';

import Scorers from './Scorers';
import Cards from './Cards';
import VallasInvictas from './VallasInvictas';

const Satatistics = (props) => {

    const { loading, teams, players } = props;

    if (loading)
        return (
            <div className="nav justify-content-center pt-2">
                <small>Cargando...</small>
            </div>
        )

    if (players && players.length > 0) {

        return (
            <div className="col-12 bg-white border border-white text-decoration-none rounded-lg p-0 mb-2 ">
                <nav className="small">
                    <div className=" rounded-lg nav nav-tabs  justify-content-center flex-row font-weight-bold" id="nav-tab" role="tablist">

                        <a className=" nav-item nav-link tab-material text-center text-dark active" id="nav-scorers-tab" data-toggle="tab" href="#nav-scorers" role="tab" aria-controls="nav-scorers" aria-selected="true">
                            <span>Goleadores</span>
                        </a>

                        <a className=" nav-item nav-link tab-material text-center text-dark " id="nav-valla-invicta-tab" data-toggle="tab" href="#nav-valla-invicta" role="tab" aria-controls="nav-valla-invicta" aria-selected="false">
                            <span>Valla Invicta</span>
                        </a>

                        <a className=" nav-item nav-link tab-material text-center text-dark " id="nav-fairplay-tab" data-toggle="tab" href="#nav-fairplay" role="tab" aria-controls="nav-fairplay" aria-selected="false">
                            <span>Fairplay</span>
                        </a>

                    </div>
                </nav>

                <div className="tab-content pt-2" id="nav-tabContent">

                    <div className="tab-pane fade show active" id="nav-scorers" role="tabpanel" aria-labelledby="nav-scorers-tab">
                        <Scorers teams={teams} players={players} />
                    </div>

                    <div className="tab-pane fade " id="nav-valla-invicta" role="tabpanel" aria-labelledby="nav-valla-invicta-tab">
                        <VallasInvictas teams={teams} players={players} />
                    </div>

                    <div className="tab-pane fade " id="nav-fairplay" role="tabpanel" aria-labelledby="nav-fairplay-tab">
                        <Cards teams={teams} players={players} />
                    </div>

                </div>

            </div>
        )
    }

    return (
        <div className="nav justify-content-center pt-2">
            <span className="small font-italic text-black-50">No hay juagadores registrados</span>
        </div>
    )
}

export default Satatistics;